import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  BarChart,
  Bar,
  LineChart,
  Line,
  Legend,
} from "recharts";
import {
  ChevronDown,
  RefreshCw,
  BarChart3,
  Download,
  TrendingUp,
  Info,
  Droplet,
} from "lucide-react";
import { ConfigProvider } from "antd";
import { motion } from "framer-motion";
import { useState, useEffect, useRef } from "react";
import { useDistrict } from "../utils/DistrictContext";
import ExampleWithDistrict from "../pages/multipleselectDropdown";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";
import * as htmlToImage from "html-to-image";
import { get, post } from "../Libraries/Ajax/HttpService";
import { createPortal } from "react-dom";
import { useTheme } from "../context/ThemeContext";
import InfoTooltip from "../components/ui/InfoTooltip";
import {
  DatePicker,
  Space,
  Select,
  Modal,
  Spin,
  Dropdown,
  Alert,
  Popover,
} from "antd";
import { toast } from "react-toastify";
import {
  getTrendData,
  getAccountTrend,
  getTrendDownloadData,
  getDownloadAccountTrend,
} from "../services/index";

export function TrendChart() {
  const { theme, colors } = useTheme();
  const TREND_COLORS = [
    "#4A90E2", // Current (RED)
    "#50E3C2", // Previous (BLUE)
    "#B8E986",
    "#B8E986",
    "#FF6F61",
    "#f89256",
    "#fbc45a",
  ];
  const [chartType, setChartType] = useState("area");
  const { selectedDistrict } = useDistrict();
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { Option } = Select;
  const [defaultOption, setDefaultOption] = useState("Year");
  const [defaultOptionss, setDefaultOptionss] = useState("Category");
  const [first, setFirst] = useState(false);
  const [sixth, setSixth] = useState("gallons");
  const [optionone, setOptionone] = useState(null);
  const [optiontwo, setOptiontwo] = useState(null);
  const [pre, setPre] = useState(null);
  const [thisr, setThisr] = useState(null);
  const [optionthree, setOptionthree] = useState(false);
  const [msgopen, setmsgopen] = useState(false);
  const [optionfour, setOptionfour] = useState(true);
  const [response, setResponse] = useState([]);
  const [callData, setcallData] = useState([]);
  const [msg, setmsg] = useState([]);
  const [selected, setSelected] = useState("Last Month");
  const [arrayData, setArrayData] = useState(null);
  const currentYear = new Date().getFullYear().toString();
  const prev = (new Date().getFullYear() - 1).toString();
  const [parameterone, setParameterone] = useState(prev);
  const [parametertwo, setParametertwo] = useState(currentYear);
  const currentDate = new Date();
  const startDate = new Date(currentDate.getFullYear(), 0, 1);
  var days = Math.floor((currentDate - startDate) / (24 * 60 * 60 * 1000));

  const [parameterthree, setParameterthree] = useState(prev);
  const [parameterfour, setParameterfour] = useState(currentYear);
  const [stringone, setStringone] = useState();
  const [stringtwo, setStringtwo] = useState();
  const [stringthree, setStringthree] = useState();
  const [stringfour, setStringfour] = useState();
  const { RangePicker } = DatePicker;

  const [myDatasex, setmyDatasex] = useState([]);
  const [myDatanew, setmyDatanew] = useState([]);
  const [merge, setMerge] = useState([]);
  const [test, setTest] = useState([]);
  const [listOfUsers, setListofUsers] = useState([]);
  const [listOfUser, setListofUser] = useState([]);
  const [status, setStatus] = useState([true]);
  const [color, setColor] = useState([]);
  const [messagecount, setMessagecount] = useState(0);
  const [count, setCount] = useState(0);
  const [inc, setInc] = useState(0);

  const [loading, setLoading] = useState(false);

  const controller = new AbortController();
  const signal = controller.signal;
  const domEl = useRef(null);
  const safeValue = (v) => (isNaN(v) || v === undefined ? 0 : v);

  const defaultStartYear = dayjs().subtract(1, "year").startOf("year");
  const defaultEndYear = dayjs().startOf("year");

  const mcData = JSON.parse(localStorage.getItem("MCData"));
  const initialDistrict = mcData?.selectedDistrict || "GPMD";

  const defaultMeterId = initialDistrict === "FB151" ? "288433" : "145330";
  const defaultMeterParam = initialDistrict === "FB151" ? "288433-" : "145330-";
  const defaultName =
    initialDistrict === "FB151" ? "429700" : "Potable Domestic";
  const defaultOverride =
    initialDistrict === "FB151" ? "429700" : "PHMSCM Holdings";
  const defaultCode = initialDistrict === "FB151" ? "DKRP0" : "DKRP1";

  const buttonRef = useRef(null);
  const [showInfoPopup, setShowInfoPopup] = useState(false);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const trendTimeOptions = [
    { label: "D", value: "day" },
    { label: "W", value: "week" },
    { label: "M", value: "month" },
    { label: "Q", value: "quarter" }, // Using 3M for Quarter
    { label: "Y", value: "year" },
  ];
  useEffect(() => {
    if (showInfoPopup && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setPopupPosition({
        top: rect.top,
        left: rect.right + 10,
      });
    }
  }, [showInfoPopup]);

  const [mySample, setmySample] = useState([defaultMeterParam]);
  const [myData, setmyData] = useState([defaultMeterId]);
  const [myDatas, setmyDatas] = useState([
    {
      meter: defaultMeterId,
      overide: defaultOverride,
      code: defaultCode,
      name: defaultName,
    },
  ]);
  const getDisplayName = (param) => {
    const currentYear = new Date().getFullYear().toString();
    return param === currentYear ? `${param} (YTD)` : param;
  };
  const isFutureDate = (optionName, parameterValue, viewMode) => {
    if (!parameterValue || !optionName) return false;
    const now = dayjs();

    try {
      if (viewMode === "Year") {
        const months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        const monthIndex = months.indexOf(optionName);
        if (monthIndex !== -1) {
          const dateToCheck = dayjs()
            .year(Number(parameterValue))
            .month(monthIndex);
          // Only true if the month is strictly after the current month
          return dateToCheck.startOf("month").isAfter(now.startOf("month"));
        }
      } else if (viewMode === "Month") {
        const dateToCheck = dayjs(
          `${parameterValue}-${String(optionName).padStart(2, "0")}`,
        );
        if (dateToCheck.isValid()) {
          // Only true if the day is strictly after the current day
          return dateToCheck.startOf("day").isAfter(now.startOf("day"));
        }
      }
    } catch (error) {
      console.error("Date calculation error:", error);
    }
    return false;
  };

  useEffect(() => {
    const fetchTrend = async () => {
      const isYearBasedMode =
        defaultOption === "Year" || defaultOption === "Quarter";

      const hasHyphen = parameterone?.includes("-");

      if (!isYearBasedMode && !hasHyphen) return;

      if (parameterone && parametertwo && defaultOptionss === "Category") {
        try {
          setLoading(true);

          const response = await getTrendData(
            defaultOption,
            parameterone,
            parametertwo,
            stringone,
            stringtwo,
          );

          const trendData = response?.data?.trend || [];

          const maxDaysP1 =
            defaultOption === "Month" ? dayjs(parameterone).daysInMonth() : 31;

          const maxDaysP2 =
            defaultOption === "Month" ? dayjs(parametertwo).daysInMonth() : 31;

          const absoluteMaxDays = Math.max(maxDaysP1, maxDaysP2);

          const formattedData = trendData
            .filter((item) => {
              if (defaultOption === "Month") {
                return parseInt(item.option_name) <= absoluteMaxDays;
              }
              return true;
            })
            .map((item) => {
              const dayNum = parseInt(item.option_name);
              let p1Val = item.first_option_sum;
              let p2Val = item.second_option_sum;

              if (defaultOption === "Month") {
                if (dayNum > maxDaysP1) p1Val = null;
                if (dayNum > maxDaysP2) p2Val = null;
              }

              if (
                p1Val === 0 &&
                isFutureDate(item.option_name, parameterone, defaultOption)
              ) {
                p1Val = null;
              }

              if (
                p2Val === 0 &&
                isFutureDate(item.option_name, parametertwo, defaultOption)
              ) {
                p2Val = null;
              }

              return {
                name: item.option_name,
                [parameterone]: p1Val,
                [parametertwo]: p2Val,
              };
            });

          setListofUsers(response?.data?.download_trend);
          setArrayData(formattedData);
        } catch (error) {
          console.error("Trend API error:", error);
          setArrayData(null);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchTrend();
  }, [
    parameterone,
    parametertwo,
    defaultOptionss,
    defaultOption,
    stringone,
    stringtwo,
    selectedDistrict,
  ]);
  // 2. Fetch Account Specific Trend Data
  // useEffect(() => {
  //   const fetchAccountData = async () => {
  //     if (
  //       defaultOptionss === "Account" &&
  //       mySample.length > 0 &&
  //       parameterone &&
  //       parametertwo
  //     ) {
  //       try {
  //         setLoading(true);
  //         const response = await getAccountTrend(
  //           defaultOption,
  //           parameterone,
  //           parametertwo,
  //           stringthree,
  //           stringfour,
  //           mySample,
  //         );

  //         const rawData = response?.data?.data || response?.data || [];

  //         const maxDaysP1 =
  //           defaultOption === "Month" ? dayjs(parameterone).daysInMonth() : 31;
  //         const maxDaysP2 =
  //           defaultOption === "Month" ? dayjs(parametertwo).daysInMonth() : 31;
  //         const absoluteMaxDays = Math.max(maxDaysP1, maxDaysP2);

  //         const formatted = rawData
  //           .filter((item) => {
  //             // Filter out rows where the day number is invalid for both months
  //             if (defaultOption === "Month") {
  //               return parseInt(item[0]?.option_name) <= absoluteMaxDays;
  //             }
  //             return true;
  //           })
  //           .map((item) => {
  //             const name = item[0]?.option_name;
  //             const dayNum = parseInt(name);
  //             const meterData = {};

  //             (item || []).forEach(({ meter_id, option }) => {
  //               let val = option;
  //               const meterIdStr = String(meter_id);

  //               // Check which period this meter belongs to
  //               const isCurrentPeriod = meterIdStr.startsWith("0");
  //               const targetMaxDays = isCurrentPeriod ? maxDaysP2 : maxDaysP1;
  //               const targetYearParam = isCurrentPeriod
  //                 ? parametertwo
  //                 : parameterone;

  //               // 1. If day doesn't exist for this month, hide the point
  //               if (defaultOption === "Month" && dayNum > targetMaxDays) {
  //                 val = null;
  //               }
  //               // 2. Hide future zeros
  //               else if (
  //                 val === 0 &&
  //                 isFutureDate(name, targetYearParam, defaultOption)
  //               ) {
  //                 val = null;
  //               }

  //               meterData[meterIdStr] = val;
  //             });

  //             return { name, ...meterData };
  //           });

  //         setMerge(formatted);
  //       } catch (error) {
  //         console.error("Account Trend API error:", error);
  //         setMerge([]);
  //       } finally {
  //         setLoading(false);
  //       }
  //     } else if (defaultOptionss === "Account") {
  //       setMerge([]);
  //     }
  //   };

  //   fetchAccountData();
  // }, [
  //   mySample,
  //   parameterone,
  //   parametertwo,
  //   defaultOption,
  //   defaultOptionss,
  //   stringthree,
  //   stringfour,
  // ]);

  useEffect(() => {
    const fetchAccountData = async () => {
      if (
        defaultOptionss === "Account" &&
        mySample.length > 0 &&
        parameterone &&
        parametertwo
      ) {
        try {
          setLoading(true);

          const response = await getAccountTrend(
            defaultOption,
            parameterone,
            parametertwo,
            stringthree,
            stringfour,
            mySample,
          );

          const rawData = response?.data?.data || response?.data || [];

          const maxDaysP1 =
            defaultOption === "Month" ? dayjs(parameterone).daysInMonth() : 31;

          const maxDaysP2 =
            defaultOption === "Month" ? dayjs(parametertwo).daysInMonth() : 31;

          const absoluteMaxDays = Math.max(maxDaysP1, maxDaysP2);

          const formatted = rawData
            .filter((item) => {
              if (defaultOption === "Month") {
                return parseInt(item[0]?.option_name) <= absoluteMaxDays;
              }
              return true;
            })
            .map((item) => {
              const name = item[0]?.option_name;
              const dayNum = parseInt(name);
              const meterData = {};

              item.forEach((row) => {
                // IMPORTANT:
                // Use meter_id because Line dataKey uses myData / myDatanew.
                // Example:
                // myData    = "151345"
                // myDatanew = "00000151345"
                // API meter_id gives exactly these values.
                const meterKey = String(row.meter_id || "");

                let val = row.flow ?? row.option ?? 0;

                const isCurrentPeriod = meterKey.startsWith("0");
                const targetMaxDays = isCurrentPeriod ? maxDaysP2 : maxDaysP1;
                const targetYearParam = isCurrentPeriod
                  ? parametertwo
                  : parameterone;

                if (defaultOption === "Month" && dayNum > targetMaxDays) {
                  val = null;
                } else if (
                  val === 0 &&
                  isFutureDate(name, targetYearParam, defaultOption)
                ) {
                  val = null;
                }

                meterData[meterKey] = val;
              });

              return {
                name,
                ...meterData,
              };
            });

          console.log("ACCOUNT GRAPH DATA:", formatted);
          console.log("SOLID LINE KEYS:", myData);
          console.log("DASHED LINE KEYS:", myDatanew);

          setMerge(formatted);
        } catch (error) {
          console.error("Account Trend API error:", error);
          setMerge([]);
        } finally {
          setLoading(false);
        }
      } else if (defaultOptionss === "Account") {
        setMerge([]);
      }
    };

    fetchAccountData();
  }, [
    mySample,
    myData,
    myDatanew,
    parameterone,
    parametertwo,
    defaultOption,
    defaultOptionss,
    stringthree,
    stringfour,
  ]);

  useEffect(() => {
    if (
      defaultOptionss === "Account" &&
      mySample.length > 0 &&
      parameterone &&
      parametertwo
    ) {
      const fetchDownloadData = async () => {
        try {
          const response = await getDownloadAccountTrend(
            defaultOption,
            parameterone,
            parametertwo,
            mySample,
          );

          // FIXED: Safely set the array data
          setListofUser(
            Array.isArray(response) ? response : response?.data || [],
          );
        } catch (error) {
          console.error("Error fetching CSV download data:", error);
        }
      };
      fetchDownloadData();
    }
  }, [mySample, parameterone, parametertwo, defaultOption, defaultOptionss]);
  useEffect(() => {
    if (!selectedDistrict?.selectedDistrict) return;

    setmySample([]);
    setmyData([]);
    setMerge([]);
    setmyDatas([]);
    setmyDatasex([]);

    const district = selectedDistrict.selectedDistrict;
    const defaultColor = color[0] || "#1F77B4";

    let config = { param: "", paramex: "", name: "", code: "", override: "" };

    if (district === "FB151") {
      config = {
        param: "288433-",
        paramex: "288433",
        name: "429700",
        code: "DKRP0",
        override: "429700",
      };
    } else if (district === "GPMD") {
      config = {
        param: "145330-",
        paramex: "145330",
        name: "Potable Domestic",
        code: "DKRP1",
        override: "PHMSCM Holdings",
      };
    }

    if (config.param) {
      setmySample([config.param]);
      setmyData([config.paramex]);

      let paddedMeter = padWithZero(
        config.paramex,
        String(config.paramex).length + 5,
      );
      setmyDatanew([paddedMeter]);

      setmyDatas([
        {
          colours: defaultColor,
          meter: config.paramex,
          overide: config.override,
          code: config.code,
          name: config.name,
        },
      ]);
      setmyDatasex([
        {
          colours: defaultColor,
          meters: paddedMeter,
          overide: config.override,
          code: config.code,
          name: config.name,
        },
      ]);

      setCount((prev) => prev + 1);
    }
  }, [selectedDistrict, color]);

  useEffect(() => {
    var user = JSON.parse(localStorage.getItem("MCData"));
    var userid = user?.userid;
    get(`apis/user_color?user_id=${userid}`).then((response) => {
      setColor(response.data.color);
    });
  }, []);

  const disabledDate = (current) => {
    return current && current > dayjs().endOf("day");
  };

  const downloadImage = async () => {
    if (!domEl.current) return;
    const dataUrl = await htmlToImage.toPng(domEl.current, {
      backgroundColor: "#0f1f30",
    });
    const link = document.createElement("a");
    link.download = `Trend-${parameterone}-${parametertwo}-${mcData?.selectedDistrict || "GPMD"}.png`;
    link.href = dataUrl;
    link.click();
  };

  const downloadMenuItems = [
    {
      label: (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            downloadImage();
          }}
        >
          Download As PNG
        </a>
      ),
      key: "0",
    },
    { type: "divider" },
    {
      label: (
        <CSVLink
          data={defaultOptionss === "Category" ? listOfUsers : listOfUser}
          filename={`Trend-${parameterone}-${parametertwo}-${mcData?.selectedDistrict || "GPMD"}.csv`}
          className="text-decoration-none"
        >
          Download As CSV
        </CSVLink>
      ),
      key: "1",
    },
  ];

  function padWithZero(num, targetLength) {
    return String(num).padStart(targetLength, "0");
  }

  const getPickerValue = (val) => {
    if (!val) return null;

    if (defaultOption === "Week") return dayjs(val, "YYYY-wo");

    // Quarter API needs only year, so picker value should be year
    if (defaultOption === "Quarter") return dayjs(val, "YYYY");

    return dayjs(val);
  };

  // Handles Year, Month, Week, Day Dropdown Changes
  const onSelect = (event) => {
    setArrayData(null);
    setMerge([]);
    const mode = event.charAt(0).toUpperCase() + event.slice(1);
    setDefaultOption(mode);

    if (event === "year") {
      setParameterone(dayjs().subtract(1, "year").format("YYYY"));
      setParametertwo(dayjs().format("YYYY"));
    } else if (event === "month") {
      setParameterone(dayjs().subtract(1, "month").format("YYYY-MM"));
      setParametertwo(dayjs().format("YYYY-MM"));
    } else if (event === "quarter") {
      setParameterone(dayjs().subtract(1, "year").format("YYYY"));
      setParametertwo(dayjs().format("YYYY"));
    } else if (event === "week") {
      setParameterone(dayjs().subtract(1, "week").format("YYYY-wo"));
      setParametertwo(dayjs().format("YYYY-wo"));
    } else {
      setParameterone(dayjs().subtract(1, "day").format("YYYY-MM-DD"));
      setParametertwo(dayjs().format("YYYY-MM-DD"));
    }
  };

  const onchanges = (date) => {
    if (!date) return;
    switch (defaultOption) {
      case "Year":
        setParameterone(date.format("YYYY"));
        break;
      case "Month":
        setParameterone(date.format("YYYY-MM"));
        break;
      case "Week":
        setParameterone(date.format("YYYY-wo"));
        break;
      case "Quarter":
        setParameterone(date.format("YYYY"));
        break;
      default:
        setParameterone(date.format("YYYY-MM-DD"));
    }
    setStringthree(date.toDate());
    setArrayData(null);
    setMerge([]);
  };

  const onchangess = (date) => {
    if (!date) return;
    switch (defaultOption) {
      case "Year":
        setParametertwo(date.format("YYYY"));
        break;
      case "Month":
        setParametertwo(date.format("YYYY-MM"));
        break;
      case "Week":
        setParametertwo(date.format("YYYY-wo"));
        break;
      case "Quarter":
        setParametertwo(date.format("YYYY"));
        break;
      default:
        setParametertwo(date.format("YYYY-MM-DD"));
    }
    setStringfour(date.toDate());
    setArrayData(null);
    setMerge([]);
  };

  const refreshClick = (e) => {
    e.stopPropagation();
    setmsgopen(true);
    post(`apis/manual_refresh?manual=start`).then((response) => {
      setmsg(response?.data?.msg);
    });
  };

  // Handles Category vs Account Dropdown Change ONLY
  const onSelects = (event) => {
    setArrayData(null);
    setMerge([]);

    if (event === "account") {
      setDefaultOptionss("Account");
      const district = selectedDistrict?.selectedDistrict || "GPMD";
      const param = district === "FB151" ? "288433-" : "145330-";
      const paramex = district === "FB151" ? "288433" : "145330";
      const overrideName = district === "FB151" ? "429700" : "PHMSCM Holdings";
      const meterCode = district === "FB151" ? "DKRP0" : "DKRP1";
      const meterName = district === "FB151" ? "429700" : "Potable Domestic";

      const defaultColor = color[0] || "#1F77B4";
      setmySample([param]);
      setmyData([paramex]);

      let paddedMeter = padWithZero(paramex, String(paramex).length + 5);
      setmyDatanew([paddedMeter]);
      setmyDatas([
        {
          colours: defaultColor,
          meter: paramex,
          overide: overrideName,
          code: meterCode,
          name: meterName,
        },
      ]);
      setCount((prev) => prev + 1);
    } else if (event === "category") {
      setDefaultOptionss("Category");
      setmyData([]);
      setmySample([]);
      setmyDatanew([]);
      setMerge([]);
      setmyDatas([]);
      setmyDatasex([]);
      setcallData([]);
    }
  };

  const handleCallback = (childData) => {
    const selectedGroups = childData?.data?.data?.meters?.selected_meters || [];

    // 1️⃣ Update sidebar exactly as dropdown
    setcallData(selectedGroups);

    // If nothing selected → clear everything
    if (selectedGroups.length === 0) {
      setmyData([]);
      setmySample([]);
      setmyDatanew([]);
      setmyDatas([]);
      setMerge([]);
      return;
    }

    // 2️⃣ Collect ALL valid meter IDs from selected accounts
    const validMeterIds = [];
    const validUniqueNames = [];

    selectedGroups.forEach((group) => {
      group.meters.forEach((meter) => {
        validMeterIds.push(meter.meter_unique_name);
        validUniqueNames.push(meter.unique_name);
      });
    });

    // 3️⃣ Remove meters that belong to closed accounts
    setmyData((prev) => prev.filter((id) => validMeterIds.includes(id)));

    setmySample((prev) =>
      prev.filter((unique) => validUniqueNames.includes(unique)),
    );

    setmyDatanew((prev) =>
      prev.filter((paddedId) =>
        validMeterIds.some((id) => paddedId.endsWith(id)),
      ),
    );

    setmyDatas((prev) =>
      prev.filter((item) => validMeterIds.includes(item.meter)),
    );
  };
  const toggleMeter = (meter) => {
    const paramex = meter.meter_unique_name;
    const isSelected = myData.includes(paramex);

    if (isSelected) {
      // Remove everywhere
      setmyData((prev) => prev.filter((id) => id !== paramex));
      setmySample((prev) => prev.filter((id) => id !== meter.unique_name));
      setmyDatanew((prev) => prev.filter((id) => !id.endsWith(paramex)));
      setmyDatas((prev) => prev.filter((d) => d.meter !== paramex));
    } else {
      // Check limit
      if (myDatas.length >= 8) {
        toast.info("Only 8 Meters can be selected at a time");
        return;
      }

      // ✅ FIXED COLOR LOGIC
      const usedColors = myDatas.map((d) => d.colours);
      const meterColor =
        color.find((c) => !usedColors.includes(c)) || "#00b8f1";

      const paddedId = padWithZero(paramex, String(paramex).length + 5);

      // Add everywhere
      setmyData((prev) => [...prev, paramex]);
      setmySample((prev) => [...prev, meter.unique_name]);
      setmyDatanew((prev) => [...prev, paddedId]);
      setmyDatas((prev) => [
        ...prev,
        {
          colours: meterColor,
          meter: paramex,
          overide: meter.overided_name || meter.name,
          code: meter.code,
          name: meter.name,
        },
      ]);
    }
  };

  const getYAxisLabel = () => {
    const kGallonPeriods = ["Year", "Month", "Week", "Quarter"];
    if (
      defaultOptionss === "Category" &&
      kGallonPeriods.includes(defaultOption)
    ) {
      return "Consumption (K Gallons)";
    }
    return "Consumption (Gallons)";
  };

  return (
    <motion.div
      className="rounded-xl p-6 relative overflow-hidden group transition-colors duration-300"
      style={{
        backgroundColor: theme === "white" ? "#ffffff" : colors.glassEffect,
        backdropFilter: "blur(10px)",
        border: `1px solid ${
          theme === "white" ? colors.border : `${colors.primary}15`
        }`,
      }}
      initial={{ opacity: 0, y: 60, rotateX: -15 }}
      animate={{ opacity: 1, y: 0, rotateX: 0 }}
      transition={{ duration: 0.7, delay: 0.65, type: "spring", bounce: 0.3 }}
      whileHover={{
        x: 10,
        transition: { type: "spring", stiffness: 300 },
      }}
    >
      <div
        className="absolute top-0 left-0 h-0.5 w-0 group-hover:w-full transition-all duration-400 ease-out rounded-full"
        style={{ backgroundImage: colors.gradient }}
      />

      <div className="relative z-10 max-[992px]:overflow-x-scroll">
        {/* HEADER CONTROLS */}
        <div className="flex items-center justify-between mb-6 flex-wrap gap-4">
          <div>
            <div className="flex items-center gap-3 mb-1">
              <div
                className="p-2 rounded-lg"
                style={{ backgroundImage: colors.gradient }}
              >
                <TrendingUp className="w-5 h-5 text-white" />
              </div>
              <h3
                className=" text-2xl font-bold tracking-tight"
                style={{ color: colors.text }}
              >
                Trend
              </h3>
              <InfoTooltip text="Aggregated view of data across the selected period to analyze overall trends."></InfoTooltip>
            </div>
          </div>

          <div className="flex items-center max-[1500px]:gap-1 gap-3 flex-wrap">
            <div className="relative">
              <select
                value={defaultOptionss.toLowerCase()}
                aria-label="Select view type"
                onChange={(e) => onSelects(e.target.value)}
                className="appearance-none rounded-lg px-4 py-2.5 pr-10 text-sm font-medium cursor-pointer transition-all duration-200 focus:outline-none"
                style={{
                  background: colors.background,
                  borderColor: colors.border,
                  color: colors.text,
                }}
              >
                <option
                  value="category"
                  style={{
                    backgroundColor:
                      theme === "white" ? "#ffffff" : colors.background,
                    color: colors.text,
                  }}
                >
                  Total
                </option>
                <option
                  value="account"
                  style={{
                    backgroundColor:
                      theme === "white" ? "#ffffff" : colors.background,
                    color: colors.text,
                  }}
                >
                  Account
                </option>
              </select>
              <ChevronDown
                className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#00b8f1] pointer-events-none"
                style={{ color: colors.textSecondary }}
              />
            </div>

            {/* API DRIVEN MULTI-SELECT DROPDOWN */}
            {defaultOptionss === "Account" && (
              // <div className="min-w-45 z-20">
              <div className="max-w-100 z-50 border border-[#00b8f1]/20 rounded-lg overflow-y-auto custom-scrollbar w-100">
                <ExampleWithDistrict
                  parentCallback={handleCallback}
                  elementValue={myData}
                  key={selectedDistrict?.selectedDistrict}
                />
              </div>
            )}

            {/* <div className="relative">
              <select
                value={defaultOption.toLowerCase()}
                onChange={(e) => onSelect(e.target.value)}
                className="appearance-none rounded-lg px-4 py-2.5 pr-10 text-sm font-medium cursor-pointer transition-all duration-200 focus:outline-none"
                style={{
                  background: colors.background,
                  borderColor: colors.border,
                  color: colors.text,
                }}
              >
                <option
                  value="year"
                  style={{
                    backgroundColor:
                      theme === "white" ? "#ffffff" : colors.background,
                    color: colors.text,
                  }}
                >
                  Year
                </option>
                <option
                  value="month"
                  style={{
                    backgroundColor:
                      theme === "white" ? "#ffffff" : colors.background,
                    color: colors.text,
                  }}
                >
                  Month
                </option>
                <option
                  value="week"
                  style={{
                    backgroundColor:
                      theme === "white" ? "#ffffff" : colors.background,
                    color: colors.text,
                  }}
                >
                  Week
                </option>
                <option
                  value="quarter"
                  style={{
                    backgroundColor:
                      theme === "white" ? "#ffffff" : colors.background,
                    color: colors.text,
                  }}
                >
                  Quarter
                </option>
                <option
                  value="day"
                  style={{
                    backgroundColor:
                      theme === "white" ? "#ffffff" : colors.background,
                    color: colors.text,
                  }}
                >
                  Day
                </option>
              </select>
              <ChevronDown
                className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#00b8f1] pointer-events-none"
                style={{ color: colors.textSecondary }}
              />
            </div> */}
            <div
              className="flex items-center p-1 rounded-lg border bg-opacity-20 shrink-0 cursor-pointer"
              style={{
                background: colors.background,
                borderColor: colors.border,
                color: colors.text,
              }}
            >
              {trendTimeOptions.map((tp) => {
                const isActive = defaultOption.toLowerCase() === tp.value;
                return (
                  <button
                    key={tp.value}
                    onClick={() => onSelect(tp.value)} // Reuses your existing onSelect function
                    className="flex-1 px-2 py-2 rounded-md text-[10px] min-[1921px]:text-[12px] font-black transition-all duration-200 uppercase cursor-pointer"
                    style={{
                      backgroundColor: isActive
                        ? colors.primary
                        : "transparent",
                      color: isActive ? "#ffffff" : colors.textSecondary,
                      boxShadow: isActive
                        ? "0 2px 4px rgba(0,0,0,0.3)"
                        : "none",
                    }}
                  >
                    {tp.label}
                  </button>
                );
              })}
            </div>

            <div className="flex items-center gap-2">
              <div
                className="border  rounded-md px-1 py-1 flex items-center w-32 hover:border-[#00b8f1]/50"
                style={{
                  backgroundColor:
                    theme === "white" ? "#ffffff" : `${colors.primary}08`,
                  // border: `1px solid ${colors.border}`,
                }}
              >
                <ConfigProvider
                  theme={{
                    components: {
                      DatePicker: {
                        colorBgContainer:
                          theme === "white" ? "#ffffff" : colors.cardBg, // background
                        colorBorder: colors.border, // border color
                        colorText: colors.text,
                        colorTextPlaceholder: colors.textSecondary,
                        controlHeight: 42,
                        borderRadius: 8,
                      },
                    },
                  }}
                >
                  <DatePicker
                    picker={
                      defaultOption === "Day"
                        ? "date"
                        : defaultOption === "Quarter"
                          ? "year"
                          : defaultOption.toLowerCase()
                    }
                    onChange={onchanges}
                    value={getPickerValue(parameterone)}
                    placeholder="From"
                    disabledDate={disabledDate}
                    suffixIcon={null}
                    allowClear={false}
                    className="w-full"
                    classNames={{ popup: `calendar-${theme}` }}
                  />
                </ConfigProvider>
              </div>
              <span className="text-[#BDB9B5]">-</span>
              <div
                className="border rounded-md px-1 py-1 flex items-center w-32 hover:border-[#00b8f1]/50"
                style={{
                  backgroundColor:
                    theme === "white" ? "#ffffff" : `${colors.primary}08`,
                  // border: `1px solid ${colors.border}`,
                }}
              >
                <ConfigProvider
                  theme={{
                    components: {
                      DatePicker: {
                        colorBgContainer:
                          theme === "white" ? "#ffffff" : colors.cardBg, // background
                        colorBorder: colors.border, // border color
                        colorText: colors.text,
                        colorTextPlaceholder: colors.textSecondary,
                        controlHeight: 42,
                        borderRadius: 8,
                      },
                    },
                  }}
                >
                  <DatePicker
                    picker={
                      defaultOption === "Day"
                        ? "date"
                        : defaultOption === "Quarter"
                          ? "year"
                          : defaultOption.toLowerCase()
                    }
                    onChange={onchangess}
                    value={getPickerValue(parametertwo)}
                    placeholder="To"
                    disabledDate={disabledDate}
                    suffixIcon={null}
                    allowClear={false}
                    className="w-full"
                    classNames={{ popup: `calendar-${theme}` }}
                  />
                </ConfigProvider>
              </div>
            </div>

            {defaultOptionss === "Account" && (
              <div
                className="flex flex-col justify-center rounded-md px-3 py-1.5 h-[42px]"
                style={{
                  backgroundColor: `${colors.primary}08`,
                  border: `1px solid ${colors.border}`,
                  backdropFilter: "blur(6px)",
                }}
              >
                <div className="flex items-center gap-3 mb-1.5">
                  <div
                    className="w-8 h-[2.5px]"
                    style={{ backgroundColor: colors.primary }}
                  ></div>
                  <span
                    className="text-[11px] font-bold min-w-[32px] text-right"
                    style={{ color: colors.text }}
                  >
                    {getDisplayName(parameterone)}
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div
                    className="w-8 border-b-[2.5px] border-dashed"
                    style={{ borderColor: colors.primary }}
                  ></div>
                  <span
                    className="text-[11px] font-bold min-w-[32px] text-right"
                    style={{ color: colors.text }}
                  >
                    {getDisplayName(parametertwo)}
                  </span>
                </div>
              </div>
            )}

            {/* EXPORT DROPDOWN MENU */}
            <Dropdown
              menu={{ items: downloadMenuItems }}
              trigger={["click"]}
              placement="bottomRight"
            >
              <button
                className="p-3 rounded-md transition-all duration-200 cursor-pointer"
                style={{
                  border: `1px solid ${colors.border}`,
                  backgroundColor: `${colors.primary}08`,
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = `${colors.primary}15`)
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = `${colors.primary}08`)
                }
                aria-label="Download report"
              >
                <Download className="w-4 h-4" style={{ color: colors.text }} />
              </button>
            </Dropdown>

            {/* Find this block in your Action Buttons section */}
            {defaultOptionss === "Category" && (
              <button
                onClick={() =>
                  setChartType(chartType === "area" ? "bar" : "area")
                }
                className="p-2 rounded-md transition-all duration-200"
                style={{
                  border: `1px solid ${
                    chartType === "bar" ? colors.primary : colors.border
                  }`,
                  backgroundColor:
                    chartType === "bar"
                      ? `${colors.primary}15`
                      : `${colors.primary}08`,
                }}
                aria-label="Toggle chart type"
              >
                <BarChart3
                  className="w-5.5 h-5.5"
                  style={{
                    color:
                      chartType === "bar"
                        ? colors.primary
                        : colors.textSecondary,
                  }}
                />
              </button>
            )}
          </div>
        </div>

        {/* WRAPPER FOR SIDEBAR & CHART CAPTURE (domEl) */}
        <div
          className="flex gap-4 w-full mt-6 pb-8 max-[992px]:w-[800px]"
          ref={domEl}
        >
          {/* INTERACTIVE ACCOUNT SIDEBAR (Visible only when Account is selected) */}
          {defaultOptionss === "Account" && (
            <div
              className="w-70 rounded-lg border flex flex-col flex-shrink-0"
              style={{
                height: "500px",
                backgroundColor: theme === "white" ? "#f8f9fa" : colors.cardBg,
                borderColor: colors.border,
              }}
            >
              {/* <div
                className="p-4 border-b"
                style={{ borderColor: colors.border }}
              ></div> */}
              <div className="p-3 overflow-y-auto custom-scrollbar flex-1 space-y-4">
                {callData?.map((person, i) => (
                  <div key={i}>
                    <h5
                      className="text-sm mb-2 opacity-90"
                      style={{ color: colors.text }}
                    >
                      {person.Overide_acc_name}
                    </h5>
                    <div className="space-y-2">
                      {person.meters.map((meter, idx) => {
                        const isSelected = myData.includes(
                          meter.meter_unique_name,
                        );
                        const selectedItem = myDatas.find(
                          (d) => d.meter === meter.meter_unique_name,
                        );
                        const itemColor = selectedItem
                          ? selectedItem.colours
                          : colors.border;

                        return (
                          <div
                            key={idx}
                            onClick={() => toggleMeter(meter)}
                            className="w-full text-left p-2 rounded-lg transition-all border cursor-pointer flex items-center gap-3"
                            style={{
                              backgroundColor: isSelected
                                ? `${itemColor}15`
                                : "transparent",
                              borderColor: isSelected
                                ? itemColor
                                : "transparent",
                            }}
                            onMouseEnter={(e) => {
                              if (!isSelected)
                                e.currentTarget.style.backgroundColor = `${colors.primary}0D`;
                            }}
                            onMouseLeave={(e) => {
                              if (!isSelected)
                                e.currentTarget.style.backgroundColor =
                                  "transparent";
                            }}
                          >
                            <div
                              className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0"
                              style={{
                                backgroundColor: isSelected
                                  ? `${itemColor}30`
                                  : `${colors.text}10`,
                              }}
                            >
                              <Droplet
                                className="w-3 h-3"
                                style={{
                                  color: isSelected
                                    ? itemColor
                                    : colors.textSecondary,
                                }}
                              />
                            </div>
                            <div className="flex-1 min-w-0">
                              {/* <div
                                className="text-xs font-medium truncate"
                                style={{ color: colors.text }}
                              >
                                {meter.name}{meter.meter_unique_name}
                              </div> */}
                              <div
                                className="flex justify-between items-center text-xs font-medium"
                                style={{ color: colors.text }}
                              >
                                {/* Truncate the name if it gets too long, add padding right so it doesn't touch the ID */}
                                <span className="truncate pr-2 text-sm">
                                  {meter.name}
                                </span>

                                {/* flex-shrink-0 prevents the ID from being squished by a long name */}
                                <span className="flex-shrink-0 opacity-80 text-xs">
                                  {meter.meter_unique_name}
                                </span>
                              </div>
                              <div
                                className="text-xs truncate mt-1"
                                style={{ color: colors.textSecondary }}
                              >
                                Date Range: {meter.date_range}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* CHART AREA */}
          <div
            className="flex-1 min-w-0 flex flex-col justify-between relative rounded-lg"
            style={{
              backgroundColor: theme === "white" ? "#ffffff" : "transparent",
            }}
          >
            {/* <div className="text-center mb-4">
              <span
                className="text-sm font-medium"
                style={{ color: colors.textSecondary }}
              >
                Consumption (Gallons)
              </span>
            </div> */}

            <ResponsiveContainer width="100%" height={500}>
              {/* MODE 1: TOTAL (Category Selection) */}
              {loading ? (
                <div className="w-full h-full flex flex-col items-center justify-center gap-3">
                  <Spin size="large" />
                  <span className="text-sm font-semibold tracking-wide" style={{ color: colors.textSecondary }}>
                    Loading Trend Analytical Matrices...
                  </span>
                </div>
              ) : defaultOptionss === "Category" ? (
             
                chartType === "area" ? (
                  <AreaChart
                    data={arrayData}
                    margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                  >
                    <CartesianGrid
                      strokeDasharray="3 3"
                      stroke={colors.border}
                    />
                    <XAxis
                      dataKey="name"
                      stroke={colors.textSecondary}
                      tick={{ fill: colors.textSecondary, fontSize: 12 }}
                    />
                    <YAxis
                      domain={[
                        0,
                        (dataMax) =>
                          dataMax === 0 ? 100 : Math.ceil(dataMax * 1.1),
                      ]}
                      stroke={colors.textSecondary}
                      tick={{ fill: colors.textSecondary, fontSize: 12 }}
                      // tickFormatter={(v) => v.toLocaleString()}
                      tickFormatter={(v) => v.toLocaleString("en-US")}
                      label={{
                        value: getYAxisLabel(),
                        angle: -90,
                        position: "insideLeft",
                        style: {
                          textAnchor: "middle",
                          fill: colors.textSecondary,
                          fontSize: 14,
                        },
                        offset: -15,
                      }}
                    />
                    <Tooltip
                      cursor={false}
                      formatter={(value, name) => [
                        // value.toLocaleString(),
                        value.toLocaleString("en-US"),
                        getDisplayName(name), // This shows '2026 (YTD)' or '2025' instead of 'Consumption'
                      ]}
                      contentStyle={{
                        backgroundColor: "#1a1510",
                        border: "1px solid #2a2520",
                        borderRadius: "8px",
                        color: "#BDB9B5",
                      }}
                    />
                    <Area
                      type="monotone"
                      dataKey={parameterone}
                      stroke={TREND_COLORS[0]}
                      strokeWidth={3}
                      fill={TREND_COLORS[0]}
                      fillOpacity={0.3}
                      name={parameterone?.toString()}
                    />
                    {/* <Area
                      type="monotone"
                      dataKey={parametertwo}
                      stroke={colors.chartColors[1]}
                      strokeWidth={3}
                      fill={colors.chartColors[2]}
                      fillOpacity={0.3}
                      name={parametertwo?.toString()}
                    /> */}
                    <Area
                      type="monotone"
                      dataKey={parametertwo}
                      stroke={TREND_COLORS[1]}
                      strokeWidth={3}
                      fill={TREND_COLORS[1]}
                      fillOpacity={0.3}
                      name={parametertwo?.toString()}
                    />
                  </AreaChart>
                ) : (
                  <BarChart
                    data={arrayData}
                    margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                  >
                    <CartesianGrid
                      strokeDasharray="3 3"
                      stroke={colors.border}
                    />
                    <XAxis
                      dataKey="name"
                      stroke={colors.textSecondary}
                      tick={{ fill: colors.textSecondary, fontSize: 12 }}
                    />
                    <YAxis
                      domain={[
                        0,
                        (dataMax) =>
                          dataMax === 0 ? 100 : Math.ceil(dataMax * 1.1),
                      ]}
                      stroke={colors.textSecondary}
                      tick={{ fill: colors.textSecondary, fontSize: 12 }}
                      // tickFormatter={(v) => v.toLocaleString()}
                      tickFormatter={(v) => v.toLocaleString("en-US")}
                      label={{
                        value: getYAxisLabel(),
                        angle: -90,
                        position: "insideLeft",
                        style: {
                          textAnchor: "middle",
                          fill: colors.textSecondary,
                          fontSize: 14,
                        },
                        offset: -10,
                      }}
                    />
                    <Tooltip
                      cursor={false}
                      formatter={(value, name) => [
                        // value.toLocaleString(),
                        value.toLocaleString("en-US"),
                        getDisplayName(name), // This shows '2026 (YTD)' or '2025' instead of 'Consumption'
                      ]}
                      contentStyle={{
                        backgroundColor: "#1a1510",
                        border: "1px solid #2a2520",
                        borderRadius: "8px",
                        color: "#BDB9B5",
                      }}
                    />
                    <Bar
                      dataKey={parameterone}
                      fill={TREND_COLORS[0]}
                      radius={[4, 4, 0, 0]}
                      name={parameterone?.toString()}
                    />
                    <Bar
                      dataKey={parametertwo}
                      fill={TREND_COLORS[1]}
                      radius={[4, 4, 0, 0]}
                      name={parametertwo?.toString()}
                    />
                  </BarChart>
                )
              ) : (
                /* MODE 2: ACCOUNT (Multi-line Selection) */
                <LineChart
                  data={merge}
                  margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                >
                  <CartesianGrid strokeDasharray="3 3" stroke={colors.border} />
                  <XAxis
                    dataKey="name"
                    stroke={colors.textSecondary}
                    tick={{ fill: colors.textSecondary, fontSize: 12 }}
                  />
                  <YAxis
                    domain={[
                      0,
                      (dataMax) =>
                        dataMax === 0 ? 100 : Math.ceil(dataMax * 1.1),
                    ]}
                    stroke={colors.textSecondary}
                    tick={{ fill: colors.textSecondary, fontSize: 12 }}
                    // tickFormatter={(v) => v.toLocaleString()}
                    tickFormatter={(v) => v.toLocaleString("en-US")}
                    label={{
                      value: getYAxisLabel(),
                      angle: -90,
                      position: "insideLeft",
                      style: {
                        textAnchor: "middle",
                        fill: colors.textSecondary,
                        fontSize: 14,
                      },
                      offset: -10,
                    }}
                  />

                  <Tooltip
                    cursor={false}
                    contentStyle={{
                      backgroundColor:
                        theme === "white" ? "#ffffff" : colors.background,
                      border: `1px solid ${colors.border}`,
                      borderRadius: "8px",
                      color: colors.text,
                    }}
                    formatter={(value, name) => {
                      const accountId = String(name).startsWith("0")
                        ? String(name).replace(/^0+/, "")
                        : String(name);

                      return [
                        `${Number(value ?? 0).toLocaleString("en-US")} Gal`,
                        accountId,
                      ];
                    }}
                  />
                  <Legend
                    verticalAlign="bottom"
                    height={36}
                    formatter={(value) => {
                      // 1. If it starts with "0" (your logic for the dotted/prev line),
                      // return null to hide the text.
                      if (value.startsWith("0")) {
                        return null;
                      }

                      // 2. Otherwise, find the friendly name for the main line
                      const account = myDatas.find((d) => d.meter === value);
                      const displayName = account ? account.overide : value;

                      // 3. Return the Name plus the Account ID (value)
                      return `${displayName} (${value})`;
                    }}
                  />

                  {/* 1. Solid Lines (Current Period) */}
                  {myData.map((meterId, index) => {
                    // Look up the specific assigned color for this meter
                    const accountObj = myDatas.find((d) => d.meter === meterId);
                    const lineColor = accountObj
                      ? accountObj.colours
                      : color[index % color.length] || "#00b8f1";

                    return (
                      <Line
                        key={`solid-${meterId}`}
                        type="monotone"
                        dataKey={meterId}
                        stroke={lineColor}
                        strokeWidth={3}
                        dot={{ r: 4 }}
                      />
                    );
                  })}

                  {/* 2. Dotted Lines (Previous Period / Comparison) */}
                  {myDatanew.map((paddedMeterId, index) => {
                    // Find matching account color by checking if the padded ID ends with the actual meter ID
                    const accountObj = myDatas.find((d) =>
                      paddedMeterId.endsWith(d.meter),
                    );
                    const lineColor = accountObj
                      ? accountObj.colours
                      : color[index % color.length] || "#00b8f1";

                    return (
                      <Line
                        key={`dashed-${paddedMeterId}`}
                        type="monotone"
                        dataKey={paddedMeterId}
                        stroke={lineColor}
                        strokeWidth={3}
                        legendType="none"
                        strokeDasharray="5 5"
                        dot={false}
                      />
                    );
                  })}
                </LineChart>
              )}
            </ResponsiveContainer>

            {/* BOTTOM LEGEND */}
            {defaultOptionss === "Category" && (
              <div className="flex items-center justify-center gap-8 mt-4 flex-wrap">
                <div className="flex items-center gap-2">
                  <div
                    className="w-4 h-4 rounded"
                    style={{ backgroundColor: TREND_COLORS[0] }}
                  ></div>
                  <span
                    className=" text-sm"
                    style={{ color: colors.textSecondary }}
                  >
                    {getDisplayName(parameterone)}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  {/* <div
                    className="w-4 h-4 rounded"
                    style={{ backgroundColor: colors.chartColors[1] }}
                  ></div> */}
                  <div
                    className="w-4 h-4 rounded"
                    style={{ backgroundColor: TREND_COLORS[1] }}
                  ></div>
                  <span
                    className=" text-sm"
                    style={{ color: colors.textSecondary }}
                  >
                    {getDisplayName(parametertwo)}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
}
